import { ShieldCheck, UserCog } from 'lucide-react';
import useAuthStore from '../store/authStore';
import PageHeader from '../components/PageHeader';
import StatusBadge from '../components/StatusBadge';
import Table from '../components/Table';
import TodoPanel from '../components/TodoPanel';
import { USERS_TODO } from '../api/users';
import { roleLabels } from '../utils/status';

const roleRows = [
  { role: 'super_admin', scope: 'Gestion total, tenants, configuracion critica' },
  { role: 'admin', scope: 'Operacion clinica, usuarios, agenda, tienda y reportes' },
  { role: 'staff', scope: 'Operacion diaria de citas, clientes, mascotas y pagos' },
  { role: 'veterinarian', scope: 'Atenciones, agenda propia, fichas clinicas' },
  { role: 'receptionist', scope: 'Agenda, clientes, mascotas y recepcion' },
  { role: 'warehouse', scope: 'Productos, stock, pedidos y entregas' },
  { role: 'viewer', scope: 'Solo lectura y reportes' }
];

const Usuarios = () => {
  const { user } = useAuthStore();

  const currentUserRows = user ? [{
    id: user.id || user.admin_id,
    email: user.email,
    role: user.role,
    tenant_id: user.tenant_id,
    is_active: true
  }] : [];

  const userColumns = [
    { key: 'email', label: 'Email' },
    { key: 'role', label: 'Rol', render: (row) => roleLabels[row.role] || row.role },
    { key: 'tenant_id', label: 'Clinica', render: (row) => row.tenant_id ? `#${row.tenant_id}` : '-' },
    { key: 'is_active', label: 'Estado', render: () => <StatusBadge label="Activo" color="green" /> }
  ];

  const roleColumns = [
    { key: 'role', label: 'Rol', render: (row) => roleLabels[row.role] || row.role },
    { key: 'scope', label: 'Alcance sugerido' }
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Usuarios internos"
        description="Gestion de accesos, roles y permisos del equipo de la clinica."
      />

      <TodoPanel title="Endpoint backend necesario para operar usuarios" items={USERS_TODO} />

      <section className="rounded-lg border border-gray-200 bg-white p-5">
        <div className="mb-4 flex items-center gap-2">
          <ShieldCheck className="h-5 w-5 text-blue-600" />
          <h2 className="text-lg font-semibold text-gray-950">Sesion actual</h2>
        </div>
        <Table columns={userColumns} data={currentUserRows} emptyMessage="Sin sesion activa" />
      </section>

      <section className="rounded-lg border border-gray-200 bg-white p-5">
        <div className="mb-4 flex items-center gap-2">
          <UserCog className="h-5 w-5 text-blue-600" />
          <h2 className="text-lg font-semibold text-gray-950">Matriz de roles esperada</h2>
        </div>
        <Table columns={roleColumns} data={roleRows} />
      </section>
    </div>
  );
};

export default Usuarios;
